import { ColumnData } from "assets/types/ColumnData";

// Columns for the admin-wide returns table, rendered with FaiDataGrid
// (field/headerName/renderCell) to match the Orders screen.
const columns: ColumnData[] = [
	{
		headerName: "Product",
		field: "productName",
		renderCell: ({ row }) => <>{row.productName}</>,
	},
	{
		headerName: "Quantity",
		field: "qty",
		renderCell: ({ row }) => <>{row.qty}</>,
	},
	{
		headerName: "Reason of return",
		field: "reason",
		renderCell: ({ row }) => <>{row.reason}</>,
	},
	{
		headerName: "Date",
		field: "date",
		renderCell: ({ row }) => <>{row.date}</>,
	},
	{
		headerName: "Amount",
		field: "price",
		renderCell: ({ row }) => <>{row.price}</>,
	},
	{
		headerName: "Status",
		field: "approvalStatus",
		renderCell: ({ row }) => {
			const s = row.approvalStatus || "REQUESTED";
			const color =
				s === "APPROVED" ? "#1a7f37" : s === "REJECTED" ? "#cf222e" : "#9a6700";
			const bg =
				s === "APPROVED" ? "#dafbe1" : s === "REJECTED" ? "#ffebe9" : "#fff8c5";
			return (
				<span
					style={{
						color,
						background: bg,
						padding: "2px 10px",
						borderRadius: 12,
						fontSize: 12,
						fontWeight: 600,
					}}
				>
					{s}
				</span>
			);
		},
	},
];

const dataTableData = {
	columns,
};

export default dataTableData;
